import moment from 'moment'

export const getQueryString = name => {
  var reg = new RegExp('(^|&|)' + name + '=([^&]*)(&|$)')
  var url =
    window.location.hash.substr(1) ||
    window.location.search ||
    window.location.href
  var r = url.match(reg)
  if (r !== null) {
    return unescape(r[2])
  } else {
    url = window.location.search || window.location.href
    r = url.match(reg)
    if (r !== null) {
      return unescape(r[2])
    }
  }
  return null
}

export const isEmpty = value => {
  if (
    value === undefined ||
    value === null ||
    value.toString().replace(/\s+/g, '') === ''
  ) {
    return true
  } else {
    return false
  }
}

export const dateFormat = (date, fmt) => {
  if (fmt === undefined || fmt === null) {
    fmt = 'yyyy-MM-dd HH:mm:ss'
  }
  if (date === '' || date === undefined) {
    return ''
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '/u661f/u671f'
          : '/u5468'
        : '') + week[this.getDay() + '']
    )
  }
  for (var k in o) {
    let rg = '(' + k + ')'
    if (new RegExp(rg).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export const deepObjectMerge = (target, ...objects) => {
  target = target || {}
  let len = objects.length
  for (let i = 0; i < len; i++) {
    let SecondOBJ = objects[i]
    for (var key in SecondOBJ) {
      target[key] =
        target[key] && target[key].toString() === '[object Object]'
          ? deepObjectMerge(target[key], SecondOBJ[key])
          : (target[key] = SecondOBJ[key])
    }
  }
  return target
}

// 时间戳转日期格式
export const dateByTimestamp = (timestamp, fmt) => {
  var newDate = new Date()
  newDate.setTime(timestamp)

  return newDate
}

export const setCookie = (cname, cvalue, exdays) => {
  if (!exdays) {
    exdays = 7
  }
  if (navigator.cookieEnabled) {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toGMTString()
    document.cookie = cname + '=' + cvalue + '; ' + expires
  } else if (localStorage) {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let curTime = d.getTime()
    localStorage.setItem(cname, JSON.stringify({ data: cvalue, time: curTime }))
  }
}

export const getCookie = cname => {
  if (navigator.cookieEnabled) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
    }
    return ''
  } else if (localStorage) {
    var data = localStorage.getItem(cname)
    var dataObj = JSON.parse(data)
    if (new Date().getTime() < dataObj.time) {
      var dataObjDatatoJson = JSON.parse(dataObj.data)
      return dataObjDatatoJson
    }
  }
  return ''
}

export const navigatorLanguage = function() {
  var type = navigator.appName
  var lang = ''
  if (type === 'Netscape') {
    lang = navigator.language
  } else {
    lang = navigator.userLanguage
  }
  return lang
}

export const getLanguage = function() {
  let cookieName = encodeURIComponent('language') + '='
  let cookieStart = document.cookie.indexOf('language')
  let cookieValue = null
  let cookieEnd
  if (cookieStart >= 0) {
    cookieEnd = document.cookie.indexOf(';', cookieStart)
    if (cookieEnd < 0) {
      cookieEnd = document.cookie.length
    }
    cookieValue = decodeURIComponent(
      document.cookie.substring(cookieStart + cookieName.length, cookieEnd)
    )
  }
  let langs = getQueryString('language')
  return cookieValue || langs || 'en'
}

export const setLocalStorage = (key, value, minute) => {
  try {
    if (!minute) {
      minute = 120
    }
    if (window.localStorage) {
      let d = new Date()
      d.setTime(d.getTime() + minute * 60 * 1000)
      let curTime = d.getTime()
      localStorage.setItem(key, JSON.stringify({ data: value, time: curTime }))
    } else if (navigator.cookieEnabled) {
      let d = new Date()
      d.setTime(d.getTime() + minute * 60 * 1000)
      let expires = 'expires=' + d.toGMTString()
      let valueStr = ''
      try {
        valueStr = JSON.stringify(value)
      } catch (error) {
        valueStr = value
      }
      document.cookie = key + '=' + valueStr + '; ' + expires
    }
  } catch (error) {}
}

export const getLocalStorage = key => {
  try {
    if (window.localStorage) {
      var data = localStorage.getItem(key)
      var dataObj = ''
      try {
        dataObj = JSON.parse(data)
      } catch (error) {
        if (data !== null) {
          return data
        }
      }
      if (new Date().getTime() < dataObj.time) {
        var dataObjDatatoJson = dataObj.data
        try {
          return JSON.parse(dataObjDatatoJson)
        } catch (error) {
          return dataObjDatatoJson
        }
      }
    } else if (navigator.cookieEnabled) {
      var name = key + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim()
        if (c.indexOf(name) === 0) {
          let varStr = c.substring(name.length, c.length)
          try {
            return JSON.parse(varStr)
          } catch (error) {
            return varStr
          }
        }
      }
      return ''
    }
  } catch (error) {
    return ''
  }
  return ''
}

export const getRandomCode = length => {
  if (!length || length < 4) {
    length = 32
  }
  var data = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]
  var nums = ''
  for (var i = 0; i < length; i++) {
    var r = parseInt(Math.random() * 61)
    nums += data[r]
  }
  return nums
}

export const getStartTime = data => {
  if (typeof data === 'number') {
    data = new Date(data)
  }
  if (!data || !(data instanceof Date)) {
    data = new Date()
  }
  data.setMilliseconds(0)
  return new Date(data.toLocaleDateString()).getTime()
}

export const getEndTime = data => {
  if (typeof data === 'number') {
    data = new Date(data)
  }
  if (!data || !(data instanceof Date)) {
    data = new Date()
  }
  data.setMilliseconds(999)
  return new Date(data.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
}

export const getCurrentDateStartAndEndTime = () => {
  const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
  start.setMilliseconds(0)
  const end = new Date(
    new Date(new Date().toLocaleDateString()).getTime() +
      24 * 60 * 60 * 1000 -
      1
  )
  end.setMilliseconds(999)
  return [start, end]
}

export const getClinetHeight = () => {
  let clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight
  }
  return clientHeight
}

export const getClinetWidth = () => {
  let clientWidth = 0
  if (document.body.clientWidth && document.documentElement.clientWidth) {
    clientWidth =
      document.body.clientWidth < document.documentElement.clientWidth
        ? document.body.clientWidth
        : document.documentElement.clientWidth
  } else {
    clientWidth =
      document.body.clientWidth > document.documentElement.clientWidth
        ? document.body.clientWidth
        : document.documentElement.clientWidth
  }
  return clientWidth
}

export const getRouterViewHeight = () => {
  try {
    let height = document.getElementById('router-view-height').clientHeight
    return height
  } catch (error) {
    return getClinetHeight() - 90
  }
}

// 获取当前开始，结束时间戳
export const getCurrentDateRange = () => {
  return [
    moment()
      .startOf('d')
      .valueOf(),
    moment()
      .endOf('d')
      .valueOf()
  ]
}

/**
 *
 * @param {*} type 最近日期的类型，取值days, weeks、months, years
 * @param {*} count
 */
export const getLastTime = (type = 'days', count = 1) => {
  let startDate = moment(new Date().setMilliseconds(0))
    .subtract(count, type)
    .startOf('d')
    .valueOf()
  startDate = startDate + 86400000
  let endDate = moment(new Date())
    .endOf('d')
    .valueOf()
  return [startDate, endDate]
}

export const dealNumber = num => {
  if (num !== 0 && num) {
    num = num + ''
    let decimalsStr = ''
    let splitList = num.split('.')
    // 先处理小数部分
    if (splitList[1]) {
      // 如果有2位小数则保留2位，只有1位则添0
      decimalsStr =
        decimalsStr.substring(0, 2).length === 2
          ? decimalsStr.substring(0, 2)
          : decimalsStr.substring(0, 2) + '0'
    }
    // 整数部分
    // 将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
    let intStrList = splitList[0]
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g)
    // 将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
    let intStr = intStrList
      .join(',')
      .split('')
      .reverse()
      .join('')
    return intStr + decimalsStr
  }
  return num
}



// WEBPACK FOOTER //
// ./src/utils/utils.js